module.exports = __webpack_public_path__ + "img/shield_fail.a5f47f21.svg";